import { render, staticRenderFns } from "./orderServiceList.vue?vue&type=template&id=9cc73c20&scoped=true"
import script from "./orderServiceList.vue?vue&type=script&lang=js"
export * from "./orderServiceList.vue?vue&type=script&lang=js"
import style0 from "./orderServiceList.vue?vue&type=style&index=0&id=9cc73c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc73c20",
  null
  
)

export default component.exports